import axiosInstance from './axiosInstance';

// Create a new sidebar menu item
export const createMenuItem = (menuItemData) =>
	axiosInstance.post('/sidebar', menuItemData);

// Get all sidebar menu items
export const getAllMenuItems = () =>
	axiosInstance.get('/sidebar').then((res) => res.data);

// Update a sidebar menu item
export const updateMenuItem = (id, updatedData) =>
	axiosInstance.put(`/sidebar/${id}`, updatedData);

// Delete a sidebar menu item
export const deleteMenuItem = (id) => axiosInstance.delete(`/sidebar/${id}`);
